import { BridgeComponent } from "@hotwired/hotwire-native-bridge";
class BarcodeComponent extends BridgeComponent {
    static component = "barcode";

    connect() {
        super.connect();
    }

    // 🔁 This method now only runs if invoked explicitly
    scanAndSearch(data = "") {
        // If code is passed, don't open scanner again.
        if (data) {
            this.performSearch(data);
        }
    }

    performSearch(code) {
        const searchUrl = `${wkhw_customForm.site_url}/?s=${encodeURIComponent(
            code,
        )}&post_type=product`;
        window.location.href = searchUrl;
        if (!wkhw_customForm.is_android) {
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }
}
export default BarcodeComponent;
